import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseTextSource } from "./BaseTextSource.js";
import { createTextStyleFromModel } from "../../../internal/models/createTextStyleFromModel.js";
/**
 * @memberOf Qualifiers.Source
 * @extends {Qualifiers.Source.BaseTextSource}
 * @description Defines how to manipulate a text layer
 */

var TextSource = /*#__PURE__*/function (_BaseTextSource) {
  _inherits(TextSource, _BaseTextSource);

  var _super = _createSuper(TextSource);

  function TextSource(fileName, textStyle) {
    _classCallCheck(this, TextSource);

    /* istanbul ignore next */
    return _super.call(this, fileName, textStyle);
  }

  _createClass(TextSource, null, [{
    key: "fromJson",
    value: function fromJson(qualifierModel, transformationFromJson) {
      var text = qualifierModel.text,
          textStyle = qualifierModel.textStyle,
          textColor = qualifierModel.textColor,
          backgroundColor = qualifierModel.backgroundColor,
          transformation = qualifierModel.transformation; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [qualifierModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this(text, textStyle ? createTextStyleFromModel(textStyle) : undefined);

      if (transformation) {
        result.transformation(transformationFromJson(transformation));
      }

      if (textColor) {
        result.textColor(textColor);
      }

      if (backgroundColor) {
        result.backgroundColor(backgroundColor);
      }

      return result;
    }
  }]);

  return TextSource;
}(BaseTextSource);

export { TextSource };